import DOMPurify from 'dompurify';

// FIX-5 (SEC LOW-3) — BE GanssHtmlContentSanitizer.PostProcessNode parity: any anchor that opens a
// new tab must carry rel="noopener noreferrer" (reverse-tabnabbing defense). Registered once at module
// load; sanitize.ts is the app's only direct DOMPurify consumer, so the hook is scoped to these calls.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.nodeName === 'A' && node.getAttribute('target')?.toLowerCase() === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const ALLOWED_TAGS = [
  'a',
  'b',
  'blockquote',
  'br',
  'code',
  'div',
  'em',
  'figure',
  'figcaption',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'i',
  'img',
  'li',
  'ol',
  'p',
  'pre',
  'q',
  's',
  'span',
  'strong',
  'sub',
  'sup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
  'u',
  'ul',
];

// BE GanssHtmlContentSanitizer AllowedAttributes parity — `class` is NOT allowed by the BE profile,
// so strip it here too (FIX-5 / SEC LOW-3). `title` is retained: it is absent from the BE set but is a
// benign accessibility attribute (tooltips) with no XSS surface, and BE already strips it on save, so
// keeping it only affects render-time defense-in-depth, never stored content.
const ALLOWED_ATTR = ['href', 'src', 'alt', 'title', 'target', 'rel'];

export function sanitizeHtml(input: string | null | undefined): string {
  if (!input) return '';
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'link', 'meta'],
    FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick'],
    KEEP_CONTENT: true,
  });
}
